
export interface ConsultationItem {
    contentExecutedInfoIdx: number;
    profileIdx: number;
    counselingIdx: number;
    endedAt: string | null;
    status: string | null;
    consultantName: string | null;
    userName: string | null;
    unitVoucherType: string | null;
    dcasResultForm: any | null;
    kpassResultForm: any | null;
    testRound: number;
    desiredDate: string | null;
    desiredTime: string | null;
    reviewWritten: boolean;
}

export interface ConsultationData {
    counselingIdx: number;
    desiredDate: string;
    desiredTime: string;
    preQuestioning: string;
    status?: string;
    review?: string | null;
    reviewCount?: number | null;
    consultantName?: string;
    reservationIdx: number;
}

export interface ConsultationReservationPostDTO{
    desiredDate: string;
}

// 예약 가능 테이블
export interface ConsultationReservation{
    idx: number,
    desiredDate: string,
    desiredTime: string,
    isReserved: boolean,
    counselingIdx: number
}

// 상담 신청 DTO
export interface ConsultationApplyDTO{
    userProfileIdx: number;
    counselingReservationIdx: number;
    contentExecutedInfoIdx: number;
    preQuestioning:string
}

// 상담 취소 DTO
export interface ConsultationCancelDTO{
    counselingIdx: number;
    userProfileIdx: number;
    counselingReservationIdx: number;
}

// 상담 수정 DTO
export interface ConsultationPutDTO{
    userProfileIdx: number;
    counselingReservationIdx: number;
    preQuestioning: string
}

interface FileDTO{
    idx: number;
    type: any;
    uri: string;
    originalFileName: string;
}

// 배정 상담사 조회
export interface ConsultantInfoDTO{
    idx: number;
    consultantName: string;
    email: string;
    phoneNumber: string;
    briefHistory: string;
    image: FileDTO;
}

// 상담 리뷰 등록
export interface ConsultantReviewPostDTO{
    reviewStar: number;
    review: string;
}

export enum ConsultationModalType{
    EDIT = "EDIT",
    DETAIL = "DETAIL",
    REVIEW = "REVIEW",
    INFO = "INFO",
}